import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

export const FOOTER_LANGUAGE_SELECT_ID = 'sitegen-language-select-wrapper';

export const SELECT_LANGUAGE_ANALYTICS_ATTRIBUTES = {
    location: 'footer',
    category: CATEGORY.ACTION,
};
export const OPEN_LANGUAGE_ANALYTICS_ATTRIBUTES = {
    location: 'footer',
    category: CATEGORY.INTERACTION,
    action: 'opens language selector'
};
